<template>
  <div class="changelog-delta">
    <!-- Handle array - START -->
    <div
      v-if="changes.length > 0"
      class="p-l-5 f-s-12"
    >
      <ul class="changelog-delta-list">
        <ChangeUpdateChanges
          :changes="changes"
          :code="code"
        />
      </ul>
    </div>
    <!-- Handle array - END -->
  </div>
</template>

<script>


import ChangeUpdateChanges from './ChangeUpdateChanges';

export default {
  name: 'ChangeLogDelta',
  components: { ChangeUpdateChanges },
  props:{
    delta: {
      type: [Object, Array],
      default: function() {
        return {};
      }
    },
    wide: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {    
      changes: [],
      code: ''
    };
  },
  mounted() {
    this._handleDeltaFormatting();
  },
  methods: {
    _addDiff(diff) {
      if (_.isObject(diff)) {
        this.code = diff;
        return '<ChangeLogPreviewBtn :diff="code" :wide="' + this.wide + '" />';
      }
      return diff;
    },
    _handleDeltaFormatting() {
      if (typeof this.delta === 'undefined') {
        return;
      }

      this._formatNode(this.delta, undefined, this.changes);
    },
    _formatNode(delta, key, changes) {
      const isRoot = typeof key === 'undefined';
      if (isRoot && typeof delta === 'undefined') {
        return;
      }
      // if it's an array, it's a leaf, add changes to...changes
      if (_.isArray(delta)) {
        if (delta.length === 1) {
          changes.push('<li class="m-b-5">' + this.added(delta, key) + '</li>');
        }
        if (delta.length === 2) {
          changes.push('<li class="m-b-5">' + this.modified(delta, key) + '</li>');
        }
        if (delta.length === 3 && delta[2] === 0) {
          changes.push('<li class="m-b-5">' + this.deleted(delta, key) + '</li>');
        }
        if (delta.length === 3 && delta[2] === 2) {
          changes.push('<li class="m-b-5">' + this.textdiff(delta, key) + '</li>');
        }
        if (delta.length === 3 && delta[2] === 3) {
          changes.push('<li class="m-b-5">' + this.moved(delta, key) + '</li>');
        }
      } else if (typeof delta === 'object') {
        // process children
        if (!isRoot) {
          const nodeHeading = typeof key === 'number' 
            ? 'Index ' + key + ' updated'
            : key;
          

          if (!changes.length) {
            changes.push('<li><a class="f-s-14 clickable" @click="hideDetails = !hideDetails">' + nodeHeading + this._returnshowDetailsButton() + '</a> ' + ' <ul class="ng-animate-disabled" v-show="!hideDetails">');
          } else {
            changes.push('<li>' + nodeHeading + '<ul>');
          }
        }
        this._forEachChild(delta, changes);
        if (!isRoot) {
          changes.push('</ul></li>');
        }
      }
    },
    _returnshowDetailsButton() {
      return '<i :class="{ \'fa-angle-down\': hideDetails, \'fa-angle-up\': !hideDetails }" class="btn btn-function white fa f-s-14 m-l-10" />';
    },
    _forEachChild(delta, changes) {
      // get keys
      const keys = this._getObjectKeys(delta);
      const arrayKeys = delta._t === 'a';
      // sort keys
      if (arrayKeys) {
        keys.sort(this._arrayKeyComparer);
      } else {
        keys.sort();
      }
      // iterate keys
      for (let index = 0, length = keys.length; index < length; index++) {
        let key = keys[index];
        
        if (arrayKeys) {
          if (key === '_t') {
            continue;
          }

          if (key.substr(0, 1) === '_') {
            delta[this._trimUnderscore(key)] = delta[key];
            delete delta[key];
          }

          key = parseInt(this._trimUnderscore(key), 10);
        }

        this._formatNode(delta[key], key, changes);
      }
    },
    _getObjectKeys(delta) {
      const names = [];
      for (const property in delta) {
        if (Object.prototype.hasOwnProperty.call(delta, property)) {
          names.push(property);
        }
      }
      return names;
    },
    _trimUnderscore(str) {
      if (str.substr(0, 1) === '_') {
        return str.slice(1);
      }
      return str;
    },
    _arrayKeyToSortNumber(key) {
      if (key === '_t') {
        return -1;
      } else {
        if (key.substr(0, 1) === '_') {
          return parseInt(key.slice(1), 10);
        } else {
          return parseInt(key, 10) + 0.1;
        }
      }
    },
    _arrayKeyComparer(key1, key2) {
      return this._arrayKeyToSortNumber(key1) - this._arrayKeyToSortNumber(key2);
    },
    added(delta, key) {
      if (typeof key === 'undefined') {
        return 'New value';
      }
      if (typeof key === 'number') {
        return 'Inserted ' + this._addDiff(delta[0]) + ' at index <strong>' + key + '</strong>';
      }
      return 'Added property <strong>' + key + '</strong> (' + this._addDiff(delta[0]) + ')';
    },
    modified(delta, key) {
      if (delta[0] == null && delta[1] != null) {
        return 'New value for <strong>' + key + '</strong>: ' + this._addDiff(delta[1]);
      }
      if (typeof key === 'undefined') {
        return 'Updated value';
      }
      if (typeof key === 'number') {
        return 'Updated index <strong>' + key + '</strong>: ' + this._addDiff(delta[0]) + ' => ' + this._addDiff(delta[1]);
      }
      return '<i>Updated property</i> <div><strong>' + key + '</strong>: <span class="highlight-diff-old">' + this._addDiff(delta[0]) + '</span> <i class="fa fa-long-arrow-right"></i> <span class="highlight-diff-new">' + this._addDiff(delta[1]) + '</span></div>';
    },
    deleted(delta, key) {
      if (typeof key === 'undefined') {
        return 'Deleted value';
      }
      if (typeof key === 'number') {
        return 'Removed index <strong>' + key + '</strong> (' + this._addDiff(delta[0]) + ')';
      }
      return 'Deleted property <strong>' + key + '</strong> (' + this._addDiff(delta[0]) + ')';
    },
    moved(delta, key) {
      return 'Move from index <strong>' + key +
          '</strong> to index ' + this._addDiff(delta[1]);
    },
    textdiff(delta, key) {
      const location =
          typeof key === 'undefined'
            ? ''
            : typeof key === 'number'
              ? ' at index <strong>' + key + '</strong>'
              : ' at property <strong>' + key + '</strong>';
      return 'Text update' + location + ': ' + delta[0] + ' => ' + delta[1];
    }
  }
};
</script>
